import { GridGame, type GridGameConfig } from "./GridGame";
import type { GuessRow } from "../components/wordle/keystate";

interface View {
  guesses: GuessRow[];
  maxGuesses: number;
  pasted: boolean;
  solution?: string;
}

const CONFIG: GridGameConfig<View> = {
  game: "wordle",
  title: "WORDLE",
  cols: 5,
  rows: (v) => v.guesses,
  errorCopy: {
    invalid_word: "Нема такого слова",
    not_in_dictionary: "Нема такого слова",
    no_puzzle: "Немає пазла на сьогодні. Скажи чіпсу.",
  },
  shakeCodes: ["invalid_word", "not_in_dictionary"],
  tooShort: "Замало літер",
  charOk: (k) => /^[a-z]$/.test(k),
  formatNumber: (n) => n.toLocaleString("en-US"),
  shareTitle: "Wordle",
  lostSubtitle: (v) => `слово було ${v.solution?.toUpperCase() ?? "?"}`,
  board: "flap",
  answer: (v) => v.solution,
};

export function Wordle({ date }: { date?: string | undefined }) {
  return <GridGame config={CONFIG} date={date} />;
}
